import { Box, FormControl, FormLabel, MenuItem, Select } from '@mui/material';
import { type Control, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { borderRadius, palette, spaces } from '../../../../assets/styles/themes/tokens';
import { collectionsSettings, muiInputFieldBorderStyle } from '../../../../constants';
import type { CollectionFormValues } from '../../types';

interface CustomColorSelectionProps {
	control: Control<CollectionFormValues>;
	initialValue?: string;
}

const ColorSelectionWrapper = ({ value, onChange, name }: any) => {
	const { t } = useTranslation();

	return (
		<Box
			sx={{
				display: 'flex',
				gap: spaces.xs,
				flexWrap: 'nowrap',
				overflow: 'hidden',
			}}
		>
			<Box
				data-testid={`custom-color-selection-color-box-${value}`}
				sx={{
					width: 40,
					height: 40,
					backgroundColor: value,
					borderRadius: borderRadius.xs,
					border: `1px solid ${palette.elevation.outlined}`,
				}}
			/>
			<FormControl fullWidth>
				<Select
					data-testid="custom-color-selection-select"
					sx={{
						width: '100%',
						height: 40,
						...muiInputFieldBorderStyle,
					}}
					value={value}
					onChange={onChange}
					name={name}
				>
					{collectionsSettings.colors.options.map((color) => (
						<MenuItem
							data-testid={`custom-color-selection-select-option-${color}`}
							key={color}
							value={color}
						>
							{t(color.charAt(0).toUpperCase() + color.slice(1))}
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</Box>
	);
};

const CustomColorSelection = ({ control, initialValue }: CustomColorSelectionProps) => {
	const { t } = useTranslation();

	return (
		<Box data-testid="custom-color-selection-container">
			<FormLabel sx={{ color: palette.text.primary }}>{t('Color')}</FormLabel>
			<Controller
				name="color"
				control={control}
				defaultValue={initialValue || collectionsSettings.colors.default}
				render={({ field }) => (
					<ColorSelectionWrapper value={field.value} onChange={field.onChange} name={field.name} />
				)}
			/>
		</Box>
	);
};

export default CustomColorSelection;
